<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="icon-screen-smartphone"></i> Terminais POS
        <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
          <i class="fa fa-plus"></i>
          Entrada
        </b-link>
      </div>
      <b-card-body>
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Empresas</label>
              <model-list-select
                :list="sellers.data"
                option-value="id"
                option-text="name"
                v-model="searchModel.sellerId"
                placeholder="Digite o nome da empresa"
                @searchchange="searchSellersList"
              ></model-list-select>
            </div>
          </div>
          <div class="col-md-2">
            <base-input
              label="Digite o serial number"
              v-model="searchModel.serialNumber"
              v-on:keyup.enter="searchModel.serialNumber"
              placeholder
            />
          </div>
          <div class="col-md-2">
            <base-input
              label="Digite o logic number"
              v-model="searchModel.logicNumber"
              v-on:keyup.enter="searchModel.logicNumber"
              placeholder
            />
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Modelo</label>
              <select :class="{'custom-select': true}" v-model="searchModel.modelId">
                <option v-for="(s, index) in deviceModelList" :key="index" :value="s.id">{{s.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Status</label>
              <select :class="{'custom-select': true}" v-model="searchModel.status">
                <option v-for="(s, index) in statusList" :key="index" :value="s.id">{{s.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="0" label class="mb-0">
              <b-input-group>
                <b-input-group-append>
                  <b-button @click="search" variant="primary">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card>
      <div class="row justify-content-center">
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Cadastrado
            </small>
            <h4 class="h4">{{summary.count}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Ativo
            </small>
            <h4 class="h4">{{summary.enabled}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Inativo
            </small>
            <h4 class="h4">{{summary.disabled}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Vinculado
            </small>
            <h4 class="h4">{{summary.attached}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Livre
            </small>
            <h4 class="h4">{{summary.open}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12">
          <div class="callout">
            <small class="text-muted">
              Total
              <br />Danificado
            </small>
            <h4 class="h4">{{summary.danified}}</h4>
          </div>
        </div>
      </div>
    </b-card>
    <b-card>
      <b-row class="float-right" v-if="isExportExcelEnabled">
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="0" label class="mb-0">
            <b-input-group>
                <b-input-group-append>                    
                    <b-button @click="exportToExcel" variant="primary">Exportar</b-button>                                    
                </b-input-group-append>
            </b-input-group>           
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        :items="result.data"
        :fields="fields"
        :striped="true"
        responsive
      >        
        <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
        <template slot="actions" slot-scope="row">        
          <button v-show="actionUri != ''" @click.prevent="onCustomActionClick('edit', row)" class="btn mr-2 btn-md btn-primary action-btn">
            <i class="fa fa-edit"></i>
          </button>
          <button v-if="row.item.status == 'OPEN'"  title="Vincular" @click.prevent="onCustomActionClick('attach', row)" class="btn mr-2 btn-md btn-dark action-btn">
            <i class="fa fa-exchange"></i>
          </button>
          <button v-if="row.item.status != 'OPEN'" title="Desvincular" @click.prevent="onCustomActionClick('detach', row)" class="btn mr-2 btn-md btn-dark action-btn">
            <i class="fa fa-eject"></i>
          </button>
        </template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="result.rowCount"
          :per-page.sync="result.pageSize"
          v-model="currentPage"
          prev-text="Voltar"
          next-text="Próximo"
          @change="pageIndexChanged"
          first-text="Primeiro"
          last-text="Último"
        />
      </nav>
    </b-card>
    <b-modal
      id="attach-modal"
      ref="modal"
      title="Vincular terminal"
      @ok="handleOk"
      @hidden="resetModal"
      ok-title="Salvar"
      cancel-title="Cancelar"
      v-model="attachModalVisible"
      :ok-disabled="attachModalButtonDisabled"
      :cancel-disabled="attachModalButtonDisabled"
    >
      <div
        class="alert alert-danger"
        role="alert"
        v-show="attachModel.hasError"
      >{{attachModel.errorMessage}}</div>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="form-row">
          <div class="col-sm-12">
             <div class="form-group">
              <label>Selecione uma empresa para vincular o terminal</label>
              <model-list-select
                :list="sellersModal.data"
                option-value="id"
                option-text="name"
                v-model="attachModel.sellerId"
                placeholder="Digite o nome da empresa"
                @searchchange="searchSellersModal"
              ></model-list-select>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import domainService from "../../../services/Devices/deviceService";
import sellerService from "../../../services/Customer/sellerService";
import deviceModelService from "../../../services/Devices/deviceModelService";
import listPage from "../../../mixins/listPage";
import config from "../../../config";
import _ from "lodash";
import { ModelListSelect } from "vue-search-select";
export default {
  components: {
    ModelListSelect
  },
  mixins: [listPage],
  data() {
    return {
      contractName: "",
      actionUri: "partners/devices",
      fields: [
        { key: "modelName", label: "Modelo", sortable: false },
        { key: "serialNumber", label: "Serial Number", sortable: false },
        { key: "logicNumber", label: "Logic Number", sortable: false },
        { key: "sellerName", label: "Empresa", sortable: false },
        { key: "contractName", label: "Contrato", sortable: false },        
        { key: "status", label: "Status", sortable: false },
        { key: "actions", label: "" }
      ],
      attachModalButtonDisabled: false,
      attachModalVisible: false,
      salesmanList: [],
      sellerList: [],
      deviceModelList: [],
      statusList: [],
      attachModel: {
        currentStatus: '',
        contractName: null,
        sellerId: null,
        sellerName: '',
        serialNumber: '',
        hasError: false,
        errorMessage: ""
      },
      summary: {
        count: 0,
        attached: 0,
        disabled: 0,
        enabled: 0,
        open: 0
      },
      searchModel: {
        serialNumber: "",
        logicNumber: "",
        modelId: null,
        status: null,
        page: 1,
        pageSize: 0,
        keywords: "",
        sellerId: 0
      },
      sellers: {
        data: [],
        query: ""
      },
      sellersModal: {
        data: [],
        query: ""
      },
      currentPage: 1
    };
  },
  computed: {
    isExportExcelEnabled: function() {
      let enabled = config.partnersConfiguration.devices.export;
      return enabled;
    },
  },
  created() {
    this.fetchModalData();
    this.fetchStatusData()
    this.fetchDeviceModelData();    
  },
  methods: {
    searchSellersModal(newQuery) {
      this.searchSellers(newQuery, true);
    },
    searchSellersList(newQuery) { 
      this.searchSellers(newQuery, false);
    },
    searchSellers(newQuery, fromModal) {
      if (newQuery == null || newQuery.length < 2) return;
      const self = this;
      this.showLoading();
      sellerService.all(newQuery).then(
        response => {
          if(fromModal) {
            self.sellersModal.data = response.status == 204 ? [] : response.data;
          }
          else
          {
            self.sellers.data = response.status == 204 ? [] : response.data;
          }
          
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    fetchDeviceModelData() {
      const self = this;
      this.showLoading();
      deviceModelService.all().then(
        response => {
          self.deviceModelList = response.status == 204 ? [] : response.data;
          self.deviceModelList.unshift({ id: null, name: "Selecione um modelo" });
          self.hideLoading();
        },
        error => {
          self.showError(error.response.data.result.errors[0].description);
          self.hideLoading();
        }
      );
    },
    fetchStatusData() {      
      this.statusList = domainService.getDeviceStatusList();
      this.statusList.unshift({
        id: null,
        name: "Selecione um status"
      });
    },
    fetchSummaryData() {
      const self = this;
      this.showLoading();
      domainService.summary(this.searchModel).then(
        response => {
          self.$data.summary = response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    fetchData(page) {
      this.searchModel.sellerId =
        this.searchModel.sellerId == 0 ? null : this.searchModel.sellerId;
      this.searchModel.page = page;      
      this.fetchDeviceData(page);
      this.fetchSummaryData();
    },
    fetchDeviceData(page) {
      const self = this;
      this.showLoading();            
      domainService.findAll(this.searchModel).then(
        response => {
          self.$data.result =
            response.status == 204 ? self.getEmptyResult() : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    fetchModalData() {
     },
    resetModal() {
      this.attachModel.sellerId = null;
      this.attachModel.serialNumber = '';
      this.attachModel.sellerName = '';
      this.attachModel.currentStatus = '';
      this.attachModel.hasError = false;
      this.attachModel.errorMessage = "";
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.attachModel.errorMessage = "";
      this.attachModel.hasError = false;
      if(this.attachModel.sellerId == null || this.attachModel.sellerId == '') {
        this.attachModel.errorMessage = "- Selecione uma empresa";
        this.attachModel.hasError = true;
          return;
      }
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {      
      const self = this;
      this.attachModalButtonDisabled = true;
      domainService.associate(this.attachModel).then(
        response => {
          self.fetchData(1);
          // Hide the modal manually
          self.$nextTick(() => {
            self.$refs.modal.hide();
            this.attachModalButtonDisabled = false;
          });
        },
        error => {
          self.attachModel.errorMessage =
            "Ocorreu um erro ao associar a maquineta.";
          self.attachModel.hasError = true;
          this.attachModalButtonDisabled = false;
        }
      );
    },
    bindStatusName(status){
      return domainService.getStatusName(status);
    },
     pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchData(page);
    },
    onCustomActionClick(action, row) {
      switch(action) {
        case 'edit':
          this.$router.push({ path: `devices/edit/${row.item.serialNumber}` });
          break;
          case 'attach':
            this.attachModel.serialNumber = row.item.serialNumber;
            this.attachModel.sellerId = row.item.sellerId;
            this.attachModel.sellerName = row.item.sellerName;
            this.attachModel.currentStatus = row.item.status;
            this.attachModel.contractName = row.item.contractName
            this.attachModalVisible = true;
          break;
          case 'detach':
            this.detachDevice(row.item.serialNumber);
            break;
      }            
    },
    detachDevice(serialNumber) {
      const self = this;
      this.showLoading();
      domainService.detach(serialNumber).then(
        (response) => {
          self.hideLoading();
          self.fetchData(1);
        },
        () => {
          self.hideLoading();
        }
      );      
    },
    exportToExcel() {
      const self = this;
      this.showLoading();
      domainService.findAllExport(this.searchModel).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    }
  }
};
</script>
